import { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

interface IProps {
  query: (options?: Partial<UseQueryOptions>) => UseQueryResult<any>;
  options?: Partial<UseQueryOptions>;
}

const NotificationCounter = ({ query, options }: IProps) => {
  const { data } = query(options);

  if (typeof data !== 'number' || data < 1) return null;
  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'red',
        color: 'white',
        height: data?.toString().length || 0 > 1 ? '18px' : '15px',
        width: data?.toString().length || 0 > 1 ? '18px' : '15px',
        borderRadius: '50%',
        fontSize: '12px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        left: '47px',
        top: '7px',
        zIndex: '999',
      }}
    >
      <span style={{ position: 'relative', bottom: '1px' }}>{data}</span>
    </div>
  );
};

export default NotificationCounter;
